var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","accept":".xlsx,.xls"},on:{"change":_vm.handleFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }